import { useEffect, useState } from 'react';
import { setToken,setRoli,setUsuarioi } from './session';
import axios, { AxiosRequestHeaders } from 'axios';
import { getPermisosUsuario } from '../Services/UsuariosService';
import { useSelector, useDispatch } from 'react-redux';
import { login, logout } from '../stores/AuthUser';
import { authInitialized } from '../stores/App';
import { Link, useNavigate } from 'react-router-dom';

export const loginSetup = async (token : any, setvalidoSesion :any,dispatch : any) => {
    
    //const [validoSesion, setvalidoSesion] = useState<boolean>(false);
    //const dispatch = useDispatch();
    //const navigate = useNavigate();
    const restProfile: any = {};
    //const redi = useSelector((state: any) => state.authUser.redi);
    setvalidoSesion(true);
    await axios.get(
        `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${token}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json',
            },
        }
    )
        .then((resProfile: any) => {
            restProfile.name = resProfile.data.name;
            //state.token = action.payload.accessToken;
            restProfile.imageUrl = resProfile.data.picture;
            restProfile.googleId = resProfile.data.id;
            restProfile.email = resProfile.data.email;
        })
        .catch((err) => console.log('err: ', err));

    await getPermisosUsuario(restProfile.googleId)
        .then((response) => {
            if (
                response.data?.data.length &&
                response.data?.data[0].tiporol_id?.pantallas?.length
            ) {
                setRoli(response.data.data[0].tiporol_id.tiporol_id);
                setUsuarioi(response.data.data[0].usuario_id);

                const data = {
                    ...restProfile,
                    usuarioId: response.data.data[0].usuario_id,
                    pantallas: response.data.data[0].tiporol_id.pantallas.filter(
                        (p) => p.selected
                    ),
                };

                dispatch(login(data));
                dispatch(authInitialized());


            }
            else if (
                response.data?.data.length &&
                response.data?.data[0].invitado == 1
            ) {
                setRoli("");
                setUsuarioi("");

                const data = {
                    ...restProfile,
                    usuarioId: 0,
                    pantallas: [],
                };

                dispatch(login(data));
                dispatch(authInitialized());

            }
            else {
                const err = response as any;
                const msg =
                    err.response.data?.meta.message ||
                    err.response.data?.meta.status ||
                    err.message;

                //StatusAlertService.showError(msg);
                setToken('');
                dispatch(logout());
            }
        })
        .catch((err) => {
            setToken('');
            dispatch(logout());
            dispatch(authInitialized());
        });
        return <div />;
}